import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { stopSpeaking } from "@/lib/audio";
import { recordUtterance, blobExt } from "@/lib/recorder";
import { setOrbState } from "@/lib/orb";

const MIC_ERR = "Microfono non disponibile. Concedi il permesso al browser.";

async function transcribe(blob) {
  const fd = new FormData();
  fd.append("file", blob, `voce.${blobExt(blob)}`);
  const { data } = await api.post("/stt", fd);
  return data.text;
}

// Quick dictation: speech becomes text in the prompt (or is sent directly with quick_voice_send).
export function useVoiceControls({ send, settings, appendInput }) {
  const [dictating, setDictating] = useState(false);
  const dictRef = useRef(null);
  const latest = useRef({});
  latest.current = { send, settings, appendInput };

  useEffect(() => () => { dictRef.current?.abort(); stopSpeaking(); setOrbState("idle"); }, []);

  const handleDictation = async (blob) => {
    setOrbState("elaborazione");
    const text = await transcribe(blob);
    if (!text) return toast.message("Non ho sentito nulla, riprova.");
    const { send: doSend, settings: s, appendInput: append } = latest.current;
    return s.quick_voice_send ? doSend(text) : append(text);
  };

  const toggleDictate = async () => {
    if (dictating) { dictRef.current?.abort(); return; }
    stopSpeaking();
    setDictating(true);
    const ctrl = new AbortController();
    dictRef.current = ctrl;
    try {
      const blob = await recordUtterance({ signal: ctrl.signal, silenceMs: 1500, idleMs: 10000 });
      if (blob) await handleDictation(blob);
    } catch (e) {
      toast.error(e?.response ? errMsg(e) : MIC_ERR);
    }
    setOrbState("idle");
    setDictating(false);
  };

  return { dictating, toggleDictate };
}
